/** Mirrors `--breakpoint-xl` in theme.css by hand: `yarn tokens` gates the CSS literals and has
    nothing to compare a TypeScript one against, so a breakpoint move is silent here. */
export const XL = "80rem";

export const atLeastXl = () => window.matchMedia(`(width >= ${XL})`).matches;

export const belowXl = () => window.matchMedia(`(width < ${XL})`);
